import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import {
  ActivitiesHttpResult,
  SessionActivitiesResult,
} from '../models/activity.model';
import { StatSportType } from '../models/stats.model';
import { IActivityApi } from './interfaces/activity-abstract.api';

@Injectable({
  providedIn: 'root',
})
export class ExternalActivityApi implements IActivityApi {
  constructor(private readonly http: HttpClient) { }

  getActivities(
    page: number,
    limit: number,
    userId: number
  ): Observable<ActivitiesHttpResult> {
    const params: HttpParams = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('includeGpsOnly', 'true')
      .set('includeWorkout', 'true')
      .set('includeFreeRide', 'true');
    const url: string = environment.api.externalUser.activitiesSessions.replace(
      '{userId}',
      '' + userId
    );
    return this.http.get<ActivitiesHttpResult>(url, { params });
  }

  getActivitiesByMonth(
    month: number,
    year: number,
    sportType: StatSportType,
    limit?: number,
    page?: number,
    userId?: number
  ): Observable<SessionActivitiesResult> {
    const params: HttpParams = new HttpParams()
      .set('month', month)
      .set('year', year)
      .set('sportType', sportType)
      .set('includeGpsOnly', 'true')
      .set('includeWorkout', 'true')
      .set('includeFreeRide', 'true');
    const url: string = environment.api.externalUser.activitiesSessions.replace(
      '{userId}',
      '' + userId
    );
    return this.http.get<SessionActivitiesResult>(url, { params });
  }
}
